import HeadData from 'components/Common/HeadData'
import { OFFER_TYPE_LAST_MINUTE } from 'constants/offer'
import { descriptionBuilder } from 'lib/descriptionBuilder'
import { scheduleIsCurrent } from 'lib/scheduleStatus'
import React from 'react'
import OfferGoogleProductDataScript from './OfferGoogleProductDataScript'
import config from 'constants/config'
import HotelStructuredData from './HotelStructuredData'

interface Props {
  offer: App.Offer;
  canonicalPath?: string;
}

function OfferPageHeadData(props: Props) {
  const { offer, canonicalPath } = props

  const availableForPurchase = scheduleIsCurrent(offer.onlinePurchaseSchedule)
  const metaDescription = descriptionBuilder(
    offer.name,
    offer?.lowestPricePackage?.price ?? 0,
    offer?.lowestPricePackage?.value ?? 0,
    config.BRAND,
    config.title,
  )

  let canonicalTag = ''

  if (config.ENABLE_ONE_PROPERTY_PAGE && offer.property) {
    canonicalTag = `/property/${offer.slug}-le:${offer.property.id}`
  } else {
    canonicalTag = `/offer/${offer.slug}/${offer.id}`
  }

  return (
    <>
      <HeadData
        title={[offer.name, offer.locationHeading, offer.locationSubheading].filter(t => t).join(', ')}
        description={metaDescription}
        noIndex={offer.noIndex || !availableForPurchase}
        canonical={canonicalPath ?? canonicalTag}
        imageId={offer.images[0].id}
      />
      {offer.property && <HotelStructuredData offer={offer} />}
      {offer.type !== OFFER_TYPE_LAST_MINUTE && (
        <OfferGoogleProductDataScript
          availableForPurchase={availableForPurchase}
          offer={offer}
        />
      )}
    </>
  )
}

export default OfferPageHeadData
